var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPermissionLevel7 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7593 5.4306L11.7633 3.03064C11.6431 2.98979 11.5143 2.98979 11.3942 3.03064L4.39821 5.4306C4.16032 5.51283 4 5.74145 4 6.00005V12C4 18.5937 11.3358 20.9512 11.4104 20.9748C11.4652 20.9916 11.5218 21 11.5789 21C11.6361 21 11.6927 20.9916 11.7475 20.9748C11.822 20.9514 19.1579 18.594 19.1579 12V6.00005C19.1579 5.74143 18.9977 5.51282 18.7593 5.4306Z",
    fill: "#3E3AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55176 15.0459H11.0996L14.0391 9.18652V8H9V9.17188H12.584V9.20117L9.55176 15.0459Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPermissionLevel7);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_permission_level_7.8a06b3455820067ad913002c9ec177a3.svg";